import React from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import TableWidget from "../../../components/tables/TableWidget";
import {
  activeTransportsTableHeader,
  getactiveTransportsTableData,
} from "./components/tableConfigs/activeTransportsTableConfig";
import ActiveTransportActionButton from "./components/TableActionsButtonsComponent/ActiveTransportsActionButton";
import EndActiveTransportModal from "./components/EndActiveTransportModal";
import { fetchActiveTransports } from "../../../redux/api/transport.api";
import { TableActions } from "../../../components/tables/tableContext/TableContext";

function ActiveTransports() {
  const dispatch = useAppDispatch();

  const {
    transport: {
      activeTransports: {
        data: { data: activeTransports },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    transport: state.transport,
  }));

  const handleTableActions = (action: TableActions) => {
    if (action.tableFilter) {
      dispatch(
        fetchActiveTransports({
          perPage: 9999,
          ruta: action.tableFilter.ruta,
        }),
      );
    }
  };

  return (
    <>
      <EndActiveTransportModal />
      <TableWidget
        tableTitle="Transporturi active"
        tableHeaderData={activeTransportsTableHeader}
        tableItemsData={getactiveTransportsTableData(activeTransports)}
        tableLoading={isLoading}
        ActionButtonsComponent={(props: any) => (
          <ActiveTransportActionButton {...props} />
        )}
        handleTableActions={handleTableActions}
        withTablePagination={false}
        borderedRow
      />
    </>
  );
}

export default ActiveTransports;
